module.exports = __webpack_public_path__ + "img/bubble-chart-bgd.e6dceb9a.svg";